export interface PostItem {
  id: number;
  title: string;
  circle: string;
  work: string;
  author: string;
  avatarColor: "primary" | "accent" | "secondary";
  time: string;
  views: string;
  replies: number;
  likes: string;
  excerpt: string;
  hot?: boolean;
  tag: string;
}

export const posts: PostItem[] = [
  {
    id: 1,
    title: "这一话的伏笔你发现了吗？星轨漂流记第126话深度解读",
    circle: "科幻星舰港",
    work: "星轨漂流记",
    author: "星际拾荒人",
    avatarColor: "accent",
    time: "2小时前",
    views: "1.2万",
    replies: 286,
    likes: "1980",
    hot: true,
    tag: "剧情解读",
    excerpt: "看完全新的126话我整个人都麻了，第37话那个一闪而过的坐标，居然在126话里被回收了……",
  },
  {
    id: 2,
    title: "暗巷侦探社凶手身份大猜想：所有反转都在暗示这个人",
    circle: "悬疑推理圈",
    work: "暗巷侦探社",
    author: "墨色推理家",
    avatarColor: "secondary",
    time: "5小时前",
    views: "2.3万",
    replies: 412,
    likes: "3100",
    hot: true,
    tag: "推理分析",
    excerpt: "重刷三遍之后我基本确定，真正的幕后黑手不是看上去最可疑的那个，而是全程都在镜头边缘的人……",
  },
  {
    id: 3,
    title: "求安利！类似苍蓝王座这种架空史诗奇幻还有哪些？",
    circle: "奇幻世界观",
    work: "苍蓝王座",
    author: "大陆绘图师",
    avatarColor: "primary",
    time: "昨天",
    views: "8600",
    replies: 178,
    likes: "920",
    tag: "求安利",
    excerpt: "苍蓝王座的世界观真的绝了，种族设定考据得好认真。求各位同好再安利几部类似的架空史诗……",
  },
  {
    id: 4,
    title: "晴空守望者最新话，这糖我磕到了，天台表白名场面",
    circle: "恋爱轻语社",
    work: "晴空守望者",
    author: "糖分超标",
    avatarColor: "primary",
    time: "昨天",
    views: "6700",
    replies: 143,
    likes: "1680",
    tag: "cp发糖",
    excerpt: "谁懂啊，最新话天台那一段的分镜真的封神了，夕阳、逆光、欲言又止……我直接原地升天。",
  },
  {
    id: 5,
    title: "深夜食堂奇谭：每个单元剧都戳中我的泪点，写个长评",
    circle: "漫画绘技营",
    work: "深夜食堂奇谭",
    author: "夜行猫",
    avatarColor: "accent",
    time: "3天前",
    views: "5400",
    replies: 96,
    likes: "1130",
    tag: "长评",
    excerpt: "这部作品真的是单元剧天花板，每一道菜都藏着一个普通人的人生。我挑几个印象最深的展开聊聊……",
  },
  {
    id: 6,
    title: "热血篮球部新赛季赛程预测，我的主队稳进八强",
    circle: "热血追番组",
    work: "热血篮球部",
    author: "第三节后卫",
    avatarColor: "secondary",
    time: "3天前",
    views: "7200",
    replies: 131,
    likes: "860",
    tag: "剧情讨论",
    excerpt: "结合漫画里的赛程安排和人员轮换，我大胆预测一下这轮赛果。欢迎各位老哥一起对答案。",
  },
];